const postCloneChecklistBySite = {
  toastr: 'Checklist Clonado',
  toastr1: 'O Modelo foi atualizado com sucesso'
};

export default postCloneChecklistBySite;
